import { AxiosError, AxiosRequestConfig } from 'axios';
import { apiGet } from '../api';
import { TValidationSerialResponse } from '../../types/suscription/productExternal.types';

const { REACT_APP_SUBSCRIPTION } = process.env;

export const getValidateSerialDetails = async (serial: string): Promise<TValidationSerialResponse> => {
  return apiGet<AxiosRequestConfig, TValidationSerialResponse>(
    `${REACT_APP_SUBSCRIPTION}/product-external/validate-serial-details/${serial}`
  )
    .then(resp => Promise.resolve(resp))
    .catch((error: AxiosError) => Promise.reject(error));
};
